import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TPreProcessChecksV2RequestSchema,
  TPreProcessChecksV2ResponseSchema,
} from "./preProcessChecksV2.schema";

export const preProcessChecksV2 = (axios: IAxiosInstance) => {
  return async (body: TPreProcessChecksV2RequestSchema) => {
    const response =
      await axios.noRetry.post<TPreProcessChecksV2ResponseSchema>(
        `/checks/pre-process`,
        body
      );

    return response.data;
  };
};
